import script from "./ButtonNeutralPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonNeutralPrimary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonNeutralPrimary.vue?vue&type=style&index=0&id=ecedcdec&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecedcdec"]])

export default __exports__